const es = {
  or: 'O',
  'auth.login': 'Iniciar sesión con SSO',
  'auth.accept': 'Acepto los',
  'auth.terms': 'Términos y condiciones',
  'auth.forgotPassword': 'Olvidé mi contraseña',
  'auth.privacyPolicy': 'Política de privacidad',
  'auth.needHelp': 'Need help? Contact',
  'auth.support': 'Support',
  'auth.cookies': 'Usamos cookies para brindarle una mejor experiencia',
  'auth.terms.toastErrorMessage': 'Por favor acepta los términos y condiciones.',
  'auth.redirectErrorToastMessage': 'An error occured during sign-in. Please try again or contact support.',

  'restore.title': 'Restablecer la contraseña',
  'restore.updatePassword': 'Actualizar contraseña',

  'restore.validation.title': 'Su contraseña debe contener al menos',
  'restore.validation.minOf': 'Mínimo de',
  'restore.validation.characters': 'caracteres',
  'restore.validation.lowerCase': 'Letra minúscula',
  'restore.validation.upperCase': 'Letra mayúscula',
  'restore.validation.number': 'Carácter numérico',
  'restore.validation.symbol': 'Personaje especial',

  'resetPassword.expired.title': 'La contraseña ha expirado',
  'resetPassword.expired.description': 'Establezca una nueva contraseña para continuar usando la aplicación',

  'confirmSignIn.timer.title': 'Inicie sesión nuevamente si no recibió el código.',
  'confirmSignIn.rememberDevice': 'Recordar este dispositivo durante 14 días',

  'crashPage.somethingWrong': 'Algo salió mal',
  'crashPage.backToLogin': 'Volver a iniciar sesión',
  'crashPage.contactAdmin': 'Por favor póngase en contacto con el administrador de su organización',

  'accessRestrictedByIp.title': 'Your IP address is not authorized for access',
  'accessRestrictedByIp.contactInfo.prefix': '¿Necesita ayuda? Contacte a su Administrador o',
  'accessRestrictedByIp.contactInfo.support': 'Soporte',
  'accessRestrictedByIp.backToLogin': 'Volver a iniciar sesión',

  'ssoFailurePage.title': 'No se le permite usar la aplicación',
  'ssoFailurePage.contactAdmin': 'Por favor póngase en contacto con el administrador de su organización',
  'ssoFailurePage.backToLogin': 'Volver a iniciar sesión',

  'maintenance.title': 'Servicio en mantenimiento',
  'maintenance.subtitle': 'Regresaremos en un momento. Por favor, inténtelo de nuevo más tarde.',
  'maintenance.subtitle2': '¡Gracias por su paciencia!',

  'forceNewPassword.newPassword.label': 'Nueva contraseña',
  'forceNewPassword.newPassword.placeholder': 'Ingrese una nueva contraseña',

  // fix default translate
  'Enter your email': 'Escriba su email',
  Code: 'Código de 6 dígitos',
  'Confirm Password': 'Confirmar Contraseña',
  'Change Password': 'Establecer nueva contraseña',
  'Please confirm your Password': 'Confirmar nueva contraseña',
  'Code *':
    'Please enter the verification code we sent to your email. If you have a confirmed phone number, you may also receive the code via text message.',
  'New Password': 'Nueva contraseña',
  'Confirm SMS Code': 'Código de verificación',
  'Incorrect username or password.': 'Usuario o contraseña invalido',
  'Invalid code or auth state for the user.':
    'Código de verificación no válido, haga clic en el enlace para regresar a la pantalla de inicio de sesión del sistema',
  'Invalid code provided, please request a code again.':
    'Código de verificación no válido, haga clic en el enlace para regresar a la pantalla de inicio de sesión del sistema',
  'Invalid verification code provided, please try again.': 'El código de verificación es incorrecto.',
  'Back to Sign In': 'Volver a la pantalla de inicio de sesión',
  'Invalid session for the user, session is expired.': 'Sesión no válida para el usuario, la sesión ha caducado.',
  'User does not exist.': 'El usuario no existe.',
  'Trial is expired.': 'El período de prueba ha expirado.',
  'Organization is not configured.': 'La organización no está configurada.',
  'Company is inactive.': 'La empresa está inactiva.',
  'Your organization has SSO enabled. You cannot login with password':
    'Su organización tiene habilitado el inicio de sesión único (SSO). No puede iniciar sesión con contraseña.',
  'Too many invalid credentials attempts. User temporarily locked. Please try again after few seconds.':
    'Debido a múltiples intentos fallidos de autenticación, la cuenta fue bloqueada por unos segundos.',
  'Rate exceeded': 'Login failed. Try again later.',
  'Too many requests': 'Login failed. Try again later.',

  'Network error':
    'cognito-idp.eu-west-1.amazonaws.com is blocked, please check your firewall settings or contact network administrator in your organization',
  'Attempt limit exceeded, please try after some time.':
    'Se superó el límite de intentos, por favor tres después de siete veces.',
  'Temporary password has expired and must be reset by an administrator.':
    'Su contraseña temporal ha caducado. Haga clic en "Olvidé mi contraseña" para enviar una nueva contraseña.',
  'Send code': 'Enviar código de verificación',
  'Access Token has been revoked': 'An error occured during sign-in. Please try again or contact support.',

  // Change Phone Page
  'phoneVerification.step1.title': 'Verify your phone number',
  'phoneVerification.step1.block1':
    "To protect your account, we need to verify your mobile number. We'll send a verification code by SMS",
  'phoneVerification.step1.block2': 'Enter your phone number for 2 factor authentication:',
  'phoneVerification.step1.phone.placeholder': 'Enter your phone number',
  'phoneVerification.step1.sendButton': 'Send verification code',
  'phoneVerification.step1.verifyButton': 'Verify',
  'phoneVerification.step1.validation.genericError': 'Failed to update phone number',
  'phoneVerification.step1.backButton': 'Back to login screen',
  'phoneVerification.step2.title': 'Enter verification code',
  'phoneVerification.step2.codeSentTo': 'We sent a 6-digit code to',
  'phoneVerification.step2.validation.codeError': 'Wrong or expired code. Please try again',
  'phoneVerification.step2.validation.genericError': 'An error occured while sending the verification code',
  'phoneVerification.step2.changePhone': 'Change your phone number',
  'phoneVerification.skipButton': 'Skip for now',
  'footer.step2.noCodeReceived': "Didn't get a code?",
  'footer.step2.resendCode': 'Resend',
  'footer.step2.changeNumber':
    'By entering your number, you agree to receive a one-time passcode (OTP) via SMS to verify your account',
};

export default es;
